import React, { useState, useEffect, useMemo } from "react";
import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { usePatientRoute } from "../../routes/usePatientRoute";
import PatientColumn from "./PatientColumn";
import PatientRightPanel from "./PatientRightPanel";
import UserStore from "../../stores/User/UserStore";
import { PatientsContext } from "../../stores/Patients/patients.provider";
import useStore from "../../helpers/useStore";
import { useScopedHotkeys } from "../../hotkeys/hooks";
import { usePatient } from "../../stores/Patients";
import { usePatientHotkeys } from "./PatientHotkeys";
import SwapPreFlightDialog from "../PatientOverview/RxInfo/RxSeries/SwapPreFlight";
import CopaymentExemptionDialog from "../PatientDataEntryForm/CopaymentExemptionDialog";
import InsuranceDataLiftoverDialog from "../PatientDataEntryForm/InsuranceDataLiftoverDialog";
import DetailLayout from "../shared/DetailLayout";

export interface PatientData {
  id: number;
  lastName?: string;
  firstName?: string;
  dob?: string;
  isActive: boolean;
}

/**
 * PatientLayoutContainer handles the layout for patient-related views,
 * 
 * TODO left to migrate to new places:
 *        const unpaidBills = await getBadgeUnpaidBillsByPatientId(parseInt(patientId));   const TransactionsStore = useStore(TransactionsContext);

 *       fetchPatientNoticeData(parseInt(patientId)); (  const { fetchPatientNoticeData } = NoticeStore;
          *   // Derived badge state
            const badge = badgeArray.length > 0 && badgeArray.some((item) => item.dueAmount);
            const countBadge = badgeArray.filter((item) => item.dueAmount).length;

 */

const PatientLayoutContainer = observer(() => {
  // URL state from route
  // const { patientId, selectedTab, rxId, doctorReportId, newdoctorReportId } = usePatientRoute();
  const PatientStore = useStore(PatientsContext);
  const {
    selectedPatientId: patientId,
    setPreflightDialogOpen,
    preflightDialogOpen,
  } = PatientStore;

  // usePatientHotkeys();

  return (
    <>
      <DetailLayout
        leftContent={<PatientColumn />}
        rightContent={<PatientRightPanel />}
        showRightPanel={!!patientId}
        fullHeight={true}
      />
      {patientId != null && <SwapPreFlightDialog patientId={patientId} />}
      <CopaymentExemptionDialog />
      <InsuranceDataLiftoverDialog />
    </>
  );
});

// Wrapper component to provide PatientLayout
const PatientLayout = () => {
  return <PatientLayoutContainer />;
};

export default PatientLayout;
